import apiClient from './apiClient'

export interface NotificationTodoPrompt {
  header?: string
  description?: string
}

export interface NotificationCounts {
  notification?: number
  release_notes?: number
  system_announcement?: number
  total?: number
  todo?: NotificationTodoPrompt
}

/**
 * Fetch unread counts for drawer badges (matches Angular loadNotificationsCount).
 * `allowUserNotification` includes user-mention counts (Liberty roles only).
 */
export async function fetchNotificationCounts(
  allowUserNotification = true,
): Promise<NotificationCounts> {
  const response = await apiClient.get<NotificationCounts | { data: NotificationCounts }>(
    '/api/notification_count',
    {
      params: { timezone: new Date().getTimezoneOffset() },
    },
  )
  const payload = response.data
  const row =
    payload &&
    typeof payload === 'object' &&
    'data' in payload &&
    payload.data &&
    typeof payload.data === 'object' &&
    ('notification' in payload.data ||
      'release_notes' in payload.data ||
      'system_announcement' in payload.data ||
      'total' in payload.data)
      ? payload.data
      : payload
  const counts = (row ?? {}) as NotificationCounts
  const notification = allowUserNotification? Number(counts.notification ?? 0) : 0;
  const releaseNotes = Number(counts.release_notes ?? 0)
  const systemAnnouncement = Number(counts.system_announcement ?? 0)
  const total = allowUserNotification ? Number(counts.total ?? notification + releaseNotes + systemAnnouncement) : Number(releaseNotes + systemAnnouncement);

  return {
    ...counts,
    notification,
    release_notes: releaseNotes,
    system_announcement: systemAnnouncement,
    total,
  }
}
